import React from "react";
import { Box } from "@mui/material";

const PageContainer = ({ children, sx = {}, ...props }) => (
  <Box
    sx={{ maxWidth: 1170, width: "100%", paddingX: 2, marginX: "auto", ...sx }}
    {...props}
  >
    {children}
  </Box>
);

export default PageContainer;
